import _extends from "@babel/runtime/helpers/extends";
import "./scss/index.scss";
import React from "react";
import ReactSVG from "react-svg";
import { Overlay } from "../..";
import { SliceComponent } from "../../../@prismic/components/SliceComponent";
import closeImg from "../../../images/x.svg";
export function ColorSamples(_ref) {
  var overlay = _ref.overlay;
  var _overlay$context$data = overlay.context.data,
      isMinimalist = _overlay$context$data.isMinimalist,
      colorSample = _overlay$context$data.colorSample;
  return React.createElement(Overlay, {
    context: overlay
  }, React.createElement("div", {
    className: "color-samples-popup"
  }, React.createElement(ReactSVG, {
    path: closeImg,
    onClick: overlay.hide,
    className: "color-samples-popup__close-icon"
  }), colorSample.map(function (z, i) {
    return React.createElement(SliceComponent, _extends({}, z, {
      isMinimalist: isMinimalist,
      key: "colorSample_".concat(i)
    }));
  })));
}